import React from 'react';
import { useGenerateCalender } from '../../hooks/useGenerateCalender';
import { useConditional } from '../../state/storeConditional ';
import PrayerCalendarStyler from '../prayerCalendar/PrayerCalendarStyler';


type Props = {
	show: boolean;
};
const PrayerCalendar = ( props: Props ) => {


	const { GenerateCalender } = useGenerateCalender();
	
	const {isReadyGenerator, isReadyToPost } = useConditional();

	React.useEffect( () => {
		if ( isReadyGenerator && isReadyToPost ) {
			GenerateCalender();
		}
	}, [ isReadyGenerator,isReadyToPost ] );

	return (
		<PrayerCalendarStyler show={props.show}/>
	);
};



export default PrayerCalendar;
